import { Dialog, styled, Theme } from '@material-ui/core';
import { ReactNode, Children, isValidElement } from 'react';
import ButtonSection from './ButtonSection';
import ContentsSection from './ContentSection';
import ModalCloseButton from './ModalCloseButton';
import ModalTitle from './ModalTitle';

interface Props {
  children?: ReactNode;
  open: boolean;
  onClose: () => void;
  maxWidth?: number;
}

const TitleType = (<ModalTitle />).type;

const ContentsType = (<ContentsSection />).type;

const ButtonSectionType = (<ButtonSection />).type;

const CloseButtonType = (<ModalCloseButton />).type;

const getChildren = (children: ReactNode, type: any) => {
  return Children.toArray(children).filter(
    (v) => isValidElement(v) && type === v.type
  );
};

const CustomizedModal = ({ children, open, onClose, maxWidth }: Props) => {
  const title = getChildren(children, TitleType);

  const contents = getChildren(children, ContentsType);

  const buttons = getChildren(children, ButtonSectionType);

  const closeButton = getChildren(children, CloseButtonType);

  return (
    <ModalWrapper open={open} onClose={onClose} customizedmaxwidth={maxWidth}>
      {closeButton}
      {title}
      {contents}
      {buttons}
    </ModalWrapper>
  );
};

export default CustomizedModal;

const ModalWrapper = styled(Dialog)(
  ({
    theme,
    customizedmaxwidth
  }: {
    theme: Theme;
    customizedmaxwidth?: number;
  }) => ({
    '& .MuiPaper-root': {
      borderRadius: 16,
      maxWidth: customizedmaxwidth ?? 476,
      width: '100%',
      [theme.breakpoints.down('md')]: {
        maxWidth: 476,
        margin: 12
      }
    }
  })
);
